
import { Injectable } from "@angular/core";
import { Misc } from "../../global-misc/misc";
import { GlobalMessageService } from "../../global-services/global-message.service";
import { VisitModel } from "../../global-data-models/visit.model";
import { VisitService } from "../../global-services/visit.service";
import { PatientService } from "../../global-services/patient.service";
import { PatientModel } from "../../global-data-models/patient.model";
import { GlobalLoadingService } from "../../global-services/global-loading.service";

export interface VisitWithAgeModel extends VisitModel {
    ageString?: string
}

@Injectable({ providedIn: "root" })
export class VisitsViewFacade {
    public constructor(
        private readonly messageService: GlobalMessageService,
        private readonly visitService: VisitService,
        private readonly patientService: PatientService,
        private readonly loadingService: GlobalLoadingService
    ) { }

    public getHumanReadableDate(date: Date): string {
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        }).format(date);
    }

    private getPatientAgeStringAtDate(patient: PatientModel, date: Date): string {
        try {
            const patientDob = new Date(patient.dateOfBirth);

            const yearDiff = date.getFullYear() - patientDob.getFullYear();
            const monthDiff = date.getMonth() - patientDob.getMonth();

            let years: number = yearDiff;
            let months: number = monthDiff;

            if (monthDiff < 0) {
                years = yearDiff - 1;
                months = monthDiff + 12;
            }

            return `${years} year${years === 1 ? '' : 's'}`//, ${months} month${months === 1 ? '' : 's'}`;
        } catch (error: unknown) {
            const errorMessage: string = Misc.getErrorMessage(error);
            this.messageService.showError("Get Patient Error", errorMessage);
            return "PATIENT_AGE_AT_DATE_ERROR";
        }
    }

    public async getVisitsWithAge(orgId: string, patientId: string): Promise<VisitWithAgeModel[]> {
        this.loadingService.show();
        try {
            const rawVisits: VisitModel[] = await this.visitService.getPatientVisits(orgId, patientId);

            const patient: PatientModel = await this.patientService.getPatient(orgId, patientId);

            return rawVisits.map((visit) => ({
                ...visit,
                ageString: this.getPatientAgeStringAtDate(patient, new Date(visit.date))
            }));
        } catch (error: unknown) {
            const errorMessage: string = Misc.getErrorMessage(error);
            this.messageService.showError("Get Visits Error", errorMessage);
            return [] as VisitModel[];
        } finally {
            this.loadingService.hide();
        }
    }

}